import { render } from "./NCheckboxGroup.vue?vue&type=template&id=028228ad&ts=true"
import script from "./NCheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./NCheckboxGroup.vue?vue&type=script&lang=ts"

import "./NCheckboxGroup.vue?vue&type=style&index=0&id=028228ad&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__